import Celosia1 from '../Celosia/Celosia (2).webp'
import Celosia2 from '../Celosia/Celosia (3).webp'
import Celosia3 from '../Celosia/Celosia (4).webp'
import Celosia4 from '../Celosia/Celosia (5).webp'
import Celosia5 from '../Celosia/Celosia (6).webp'
import Celosia6 from '../Celosia/Celosia (7).webp'



const Celosiaimages =[
Celosia1,Celosia2,Celosia3,Celosia4,Celosia5,Celosia6
]

export default Celosiaimages;